export default __webpack_public_path__ + "static/media/DOT.eaa9fecd.svg";